import { render, staticRenderFns } from "./AsfHelpText.vue?vue&type=template&id=31fd7f49"
import script from "./AsfHelpText.vue?vue&type=script&lang=js"
export * from "./AsfHelpText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports